/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { HiOutlineChatAlt2, HiOutlinePencil } from "react-icons/hi";

import ListPage from "../../layout/ListPage";
import type { Action, Column } from "../../ui";
import { useStaticContext } from "../../context/StaticContext";
import { pushOneAiChatInfo } from "../../lib/sysNavigation/SysNavigation";

type AiChatInfoRow = {
  ai_chat_info_id: number | string;
  title?: string;
  description?: string;
  [key: string]: unknown;
};

const editRoute = "/ai_chat_info/edit";

const Overview: React.FC = () => {
  const navigate = useNavigate();
  const { aiChatInfo, fetchAiChatInfo } = useStaticContext() as any;

  useEffect(() => {
    if (!aiChatInfo) fetchAiChatInfo();
  }, [aiChatInfo]);

  const rows = useMemo<AiChatInfoRow[] | null>(() => {
    if (!Array.isArray(aiChatInfo)) return null;
    return aiChatInfo as AiChatInfoRow[];
  }, [aiChatInfo]);

  const columns: Column<AiChatInfoRow>[] = [
    {
      header: "Title",
      cell: (row) => (
        <span className="font-medium text-gray-900">{row.title ?? "—"}</span>
      ),
    },
    {
      header: "Description",
      cell: (row) => (
        <span className="line-clamp-2 text-gray-600">{row.description ?? "—"}</span>
      ),
    },
  ];

  const rowActions = (row: AiChatInfoRow): Action[] => [
    {
      label: "Edit",
      icon: <HiOutlinePencil className="h-3.5 w-3.5" />,
      onClick: () => {
        pushOneAiChatInfo(row);
        navigate(editRoute);
      },
    },
  ];

  return (
    <ListPage<AiChatInfoRow>
      title="AI Chat Info"
      subtitle="Talking points the AI assistant draws from."
      icon={<HiOutlineChatAlt2 className="h-5 w-5" />}
      rows={rows}
      columns={columns}
      rowKey={(r) => r.ai_chat_info_id}
      rowActions={rowActions}
      empty="No AI chat info yet."
    />
  );
};

export default Overview;
